import { useGLTF } from "@react-three/drei";
import { ITochiItem } from "@snackpass/snackpass-types";
import React, { useEffect } from "react";
import { getTochiMaterial } from "src/utils/Tochi/TochiMaterials/getTochiMaterial";
import { loadShaderChunks } from "src/utils/Tochi/TochiShaders/TochiShaderChunks";
import { suspend } from "suspend-react";
import { AnimationObjectGroup } from "three";

type Props = {
  item: ITochiItem;
  animGroup: AnimationObjectGroup;
};

const TochiItem = React.memo(
  ({ item, animGroup }: Props) => {
    const { scene } = useGLTF(item.asset.rig.asset) as any;

    const handleSetMaterials = async () => {
      if (!scene) return;
      loadShaderChunks();
      const mat = await getTochiMaterial(item.asset.material).get();
      scene.traverse(async (child: any) => {
        if (child.isMesh) {
          child.material = mat;
          child.visible = true;
        }
      });
    };

    const loadedScene = suspend(async () => {
      if (!scene) return;
      await handleSetMaterials();
      return scene;
    }, [scene]);

    useEffect(() => {
      if (!loadedScene) return;
      handleSetMaterials();
    }, [loadedScene, item.asset.material]);

    useEffect(() => {
      if (!scene) return;
      animGroup.add(scene);
      return () => {
        animGroup.remove(scene);
      };
    }, [scene]);

    return <primitive object={loadedScene} />;
  },
  (a, b) => a.item._id === b.item._id
);

export default TochiItem;
